import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {AuthService} from "../../services/auth.service";
import {Router} from "@angular/router";
import {LanguageService} from "../../services/language.service";
import {timer} from "rxjs";
import { MatButton } from '@angular/material/button';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatButton, TranslocoModule]
})
export class ForgotPasswordComponent implements OnInit{
  private authService = inject(AuthService);
  private formBuilder = inject(FormBuilder);
  private router = inject(Router);
  languageService = inject(LanguageService);

  forgetForm!: FormGroup;
  submitError = false;
  resetSend = false;

  ngOnInit(): void {
    this.forgetForm = this.formBuilder.group({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  forgetPassword() {
    if (this.forgetForm?.valid) {
      this.authService.forgetPassword(this.forgetForm.value.email)
        .then(() => {
          this.resetSend = true;
          timer(5000).subscribe(() => {
            this.router.navigate(['/']);
          })
        })
        .catch(() => {
          this.submitError = true;
        });
    } else {
      this.submitError = true;
    }
  }

  login() {
    this.router.navigate(['/login'])
  }

}
